import {debounce} from '../_functions'
import {definitionFeed, letterDefinitionFeed} from "../_templates";

const object = vnObject
document.addEventListener('DOMContentLoaded', function (dom) {
    const ptGlossary = dom.target.querySelector('.pt-glossary')

    const formData = new FormData()
    formData.append('action', 'vn_glossary')
    formData.append('glossary', 'glossary')

    const options = {
        method: 'POST',
        body: formData,
        headers: {
            Accept: 'application/json',
        },
    }

    if (ptGlossary) {
        const searchInput = dom.target.querySelector('.js-search-input')
        const letters = dom.target.querySelector('.js-letters')
        const category = dom.target.querySelector('.js-category')
        const filtersButton = dom.target.querySelector('.js-filters-button')
        const filtersButtonClose = dom.target.querySelector('.js-filters-button-close')
        const filtersContainer = dom.target.querySelector('.js-filters')
        const definitions = ptGlossary.querySelector('.container__definitions')
        const notificationBar = dom.target.querySelector('.part-notification')
        const handleInput = debounce(() => {
            formData.append('search', searchInput.value)
            formData.append('category_id', category.value)
            fetch(object.ajaxUrl, options)
                .then((response) => response.json())
                .then((res) => {
                    if (res.success) {
                        let output = ``;
                        let lettersOutput = ``;
                        if (Object.keys(res.data.definitions).length) {
                            for (const definition of Object.keys(res.data.definitions)) {
                                lettersOutput += `
    <a href="#feed-definition-letter-${definition.toLowerCase()}" class="letters__letter">
        ${definition}
    </a>
`

                                lettersOutput += Object.keys(res.data.definitions).at(-1) === definition
                                    ? ''
                                    : '<span class="letters__separator">|</span>'
                                output += '<div class=\'definitions__group\'>'
                                output += letterDefinitionFeed(definition)
                                output += '<div class=\'group__list\'>'
                                for (const definitionElement of res.data.definitions[definition]) {
                                    output += definitionFeed(definitionElement, searchInput.value.trim().toLowerCase())
                                }
                                output += '</div>'
                                output += '</div>'
                            }
                        }
                        letters.innerHTML = lettersOutput;
                        definitions.innerHTML = output
                    }
                })
                .catch((error) => {
                    console.error('Erreur:', error)
                })
        }, 300)
        if (searchInput) {
            searchInput.addEventListener('input', handleInput)
        }

        if (category) {
            category.addEventListener('change', handleInput)
        }

        if (filtersButton && filtersContainer && filtersButtonClose) {
            filtersButton.addEventListener('click', () => {
                filtersContainer.classList.toggle('active');
                notificationBar.classList.toggle('hide');
            })
            filtersButtonClose.addEventListener('click', () => {
                filtersContainer.classList.remove('active');
                notificationBar.classList.toggle('hide');
            })
        }
    }
})

